import { createGroundElevation } from '../../../site/groundElevation';
import { elevatedChunks } from '../../mesh/elevatedBuilder';
import type { BuildContext, FeatureOutput, Obstacle, WorldFeature } from '../../types';
import { LASTAGE_YARD, yardFootprints, type YardItem } from './lastageYard';
import { drawLastageYard, PAINTED_YARD_EARTH } from './lastageYardMesh';

/** The walker goes round every stack, pile and beam. */
export function yardObstacles(items: readonly YardItem[]): Obstacle[] {
  return items.flatMap((item) =>
    yardFootprints(item).map((polygon, i) => ({ id: `lastageYard:${item.id}:${i}`, kind: 'structure' as const, polygon }))
  );
}

/* The timber yard the 1544 woodcut draws on the Lastage along the Geldersekade (docs/plans/lastage.md);
   its timber takes the painted hull brown the quay goods take, its kettle the painting's darkest ink. */
export const lastageYardFeature: WorldFeature = {
  id: 'fabric:lastageYard',
  label: 'Lastage yard',
  weight: 1,
  build(ctx: BuildContext): FeatureOutput {
    const colors = { timber: ctx.palette.shipHull.median.linear, earth: PAINTED_YARD_EARTH, iron: ctx.palette.lineworkDark.median.linear };
    const drawn = drawLastageYard(LASTAGE_YARD, colors, elevatedChunks(ctx.chunks, createGroundElevation(ctx.layout)));
    return {
      objects: [],
      obstacles: yardObstacles(LASTAGE_YARD),
      animated: [],
      counts: { lastageYard: drawn.items, lastageYardTriangles: drawn.triangles },
    };
  },
};
